// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "vjs" + "." + "88e4fe85ba23024b2c98" + ".css";
};